<template>
  <div id="app">
    <loader-page></loader-page>
    <v-app id="inspire">
      <template>
        <pdv-maps v-if="show_pdv_maps === true"></pdv-maps>
        <spots-maps v-if="show_spots_maps === true"></spots-maps>
        <qr-code v-if="show_qr_code === true"></qr-code>
        <terms v-if="show_terms === true"></terms>
        <policy v-if="show_policy === true"></policy>
        <Faq v-if="show_faq === true"/>
        <div class="d-flex justify-center">
          <PublicActivation v-if="show_authless_activation === true"/>
        </div>
      </template>
      <template v-if="informationPage === 'true'  && show_pages === false">
        <information-page></information-page>
      </template>
      <template v-else-if="hasTokenPassword  && show_pages === false">
        <remember-password></remember-password>
      </template>
      <template v-else-if="!hasToken() && show_pages === false">
        <landing-page></landing-page>
      </template>
      <template v-else-if="hasToken() && confirmationRequired === true  && show_pages === false">
        <confirm-register></confirm-register>
      </template>
      <template v-else-if="hasToken() && confirmationRequired === false && show_pages === false">
        <header class="header" :style="{'background-color':this.appColor}">
          <div class="container-fluid">
                        <span class="mobile-btn" :class="{'active':show.menu_mobile}"
                              @click.prevent="show.menu_mobile = !show.menu_mobile"></span>
            <div class="row other-right">
              <div class="nav-user" @click.prevent="show.nav_menu = !show.nav_menu">
                <span>Olá, {{ user.name }}</span>
                <i class="fas fa-angle-down ml-auto" :class="{'rotate':show.nav_menu}"></i>
              </div>
              <div class="nav-user-active" v-show="show.nav_menu"
                   :style="{'background-color':this.appColor}">
                <ul>
                  <router-link tag="li"
                               v-on:click.native="show.nav_menu = !show.nav_menu"
                               :to="{name: 'profile'}">
                    Meu Perfil
                  </router-link>
                  <router-link tag="li"
                               v-on:click.native="show.nav_menu = !show.nav_menu"
                               :to="{name: 'notifications'}">
                    Notificações
                  </router-link>
                  <li @click="logout()">Sair</li>
                </ul>
              </div>
            </div>
          </div>
        </header>
        <section class="construct-container">
          <nav class="nav" :class="{'active' : show.menu_mobile}">
            <img :src="logo_url" class="logo-size" alt="logo">
            <ul>
              <li class="title-list"><p class="app-name"><a>{{ app_name }}</a></p></li>

              <router-link tag="li"
                           :class="{'active':activeItemMenu === 'home'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name: 'home'}">
                <h6><i class="fas fa-home"></i> Página Inicial</h6>
              </router-link>
              <router-link tag="li"
                           :class="{'active':activeItemMenu === 'vehicles'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'vehicles'}">
                <h6><i class="fas fa-car-alt"></i> Meus Veículos</h6>
              </router-link>
              <router-link tag="li"
                           v-if="activateVehicles === 'true'"
                           :class="{'active':activeItemMenu === 'activation'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'activation'}">
                <h6><i class="fas fa-map-marker-alt"></i> Estacionar Veículo</h6>
              </router-link>
              <router-link tag="li"
                           v-if="buyCredits === 'true'"
                           :class="{'active':activeItemMenu === 'buyCredit'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'buyCredit'}">
                <h6><i class="fas fa-dollar-sign"></i> Comprar Crédito</h6>
              </router-link>

              <router-link tag="li"
                           v-if="showWallets === 'true'"
                           :class="{'active':activeItemMenu === 'wallets'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'wallets'}">
                <h6><i class="fas fa-wallet"></i> Meus Créditos</h6>
              </router-link>
              <router-link tag="li"
                           v-if="activationsOCRHistory === 'false'"
                           :class="{'active':activeItemMenu === 'history'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'history'}">
                <h6><i class="fas fa-stream"></i> Histórico</h6>
              </router-link>
              <router-link tag="li"
                           v-if="regularize === 'true'"
                           :class="{'active':activeItemMenu === 'regularize'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'regularize'}">
                <h6><i class="fas fa-exclamation-circle"></i> Irregularidades</h6>
              </router-link>
              <a
                  class="external-link"
                  href="/mapa-de-vagas"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <li
                    @click="show.menu_mobile = false"
                >
                  <h6><i class="fas fa-map-marked-alt"></i> Mapa de vagas</h6>
                </li>
              </a>
              <a
                  class="external-link"
                  href="/pontos-de-venda"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <li
                    @click="show.menu_mobile = false"
                >
                  <h6><i class="fas fa-map-marked-alt"></i> Mapa de PDV</h6>
                </li>
              </a>
              <router-link tag="li"
                           :class="{'active':activeItemMenu === 'faq'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'faq'}">
                <h6><i class="fas fa-headset"></i> Central de Ajuda</h6>
              </router-link>
              <router-link tag="li"
                           v-if="activationsOCRHistory === 'false'"
                           :class="{'active':activeItemMenu === 'user'}"
                           v-on:click.native="show.menu_mobile = false"
                           :to="{name:'profile'}">
                <h6><i class="fas fa-user-circle"></i> Meus Dados</h6>
              </router-link>
              <!--                            <li @click.prevent="show.menu_mobile = false"><h6>-->
              <!--                                <router-link :to="{name:'settings'}">-->
              <!--                                    <i class="fas fa-cog"></i> Configurações-->
              <!--                                </router-link>-->
              <!--                            </h6></li>-->
              <template v-if="show.menu_mobile">
                <router-link tag="li"
                             v-on:click.native="show.menu_mobile = !show.menu_mobile"
                             :to="{name: 'profile'}">
                  <h6><i class="fas fa-user-alt"></i> Meu Perfil</h6>
                </router-link>
                <router-link tag="li"
                             v-on:click.native="show.menu_mobile = !show.menu_mobile"
                             :to="{name: 'notifications'}">
                  <h6><i class="fas fa-user-alt"></i> Notificações</h6>
                </router-link>
                <li @click="logout()"><h6>
                  <i class="fas fa-times-circle"></i> Sair
                </h6></li>
              </template>
            </ul>
          </nav>
          <section class="content">
            <router-view></router-view>
          </section>
        </section>
      </template>
      <v-dialog v-show="modal_confirm_email.modal" class="confirmEmail text-center mb-5"
                v-model="modal_confirm_email.modal" width="350px">
        <v-card v-if="modal_confirm_email.success" class="text-center">
          <v-card-title>
            <h5 style="color: #000 !important;">E-MAIL CONFIRMADO COM SUCESSO !</h5>
          </v-card-title>
          <v-card-text>
            <h6>Seu e-mail foi confirmado com sucesso. Acesse sua conta para começar a utilizar o Estar
              Digital.</h6>
            <button class="btn-blue mx-auto mt-5"
                    @click.prevent="modal_confirm_email.modal = false;refreshPage()">OK
            </button>
          </v-card-text>
        </v-card>
        <v-card v-else class="text-center">
          <v-card-title>
            <h5 style="color: #e72c1f !important;">E-MAIL NÃO CONFIRMADO !</h5>
          </v-card-title>
          <v-card-text>
            <h6>Ocorreu um erro na cofirmação do seu e-mail. Acesse sua conta e solicite uma nova
              confirmação.</h6>
            <button class="btn-cancel mx-auto mt-5 "
                    @click.prevent="modal_confirm_email.modal = false;refreshPage()">OK
            </button>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>
<script>
import axios from 'axios';
import RememberPassword from './views/LandingPage/RememberPassword'
import ConfirmRegister from './views/LandingPage/ConfirmRegister';
import LandingPage from './views/LandingPage/LandingPage'
import InformationPage from "./views/LandingPage/InformationPage";
import LoaderPage from "./components/loaderPage";
import QrCode from "./views/QrCode";
import PdvMaps from "./views/PdvMaps";
import Terms from "./views/Terms";
import Policy from "./views/Policy";
import Faq from "@/views/Faq.vue";
import PublicActivation from "@/views/Public/PublicActivation.vue";
import SpotsMaps from "./views/SpotsMaps.vue";

export default {
  name: 'App',
  components: {
    PublicActivation,
    Faq,
    QrCode,
    PdvMaps,
    Terms,
    Policy,
    LoaderPage,
    InformationPage,
    LandingPage,
    ConfirmRegister,
    RememberPassword,
    SpotsMaps,
  },
  data: function () {
    return {
      show_pages: false,
      show_pdv_maps: false,
      show_spots_maps: false,
      show_qr_code: false,
      show_terms: false,
      show_policy: false,
      show_faq: false,
      show_authless_activation: false,
      modal_confirm_email: {
        modal: false,
        success: false
      },
      tokenPassword: false,
      required: null,
      show: {
        nav_menu: false,
        menu_mobile: false
      },
      user: {
        name: null,
      },
      alertMessage: {
        name: null,
        message: null,
        type: null
      }
    }
  },
  mounted: function () {
    if (JSON.parse(localStorage.getItem('user'))) {
      this.user.name = JSON.parse(localStorage.getItem('user')).name.split(" ")[0];
    }

    if (this.$route.path === '/pontos-de-venda') {
      this.show_pages = true;
      this.show_pdv_maps = true;
    }

    if (this.$route.path === '/mapa-de-vagas') {
      this.show_pages = true;
      this.show_spots_maps = true;
    }

    if (this.$route.path === '/qrcode') {
      this.show_pages = true;
      this.show_qr_code = true;
    }

    if (this.$route.path === '/termos-de-uso') {
      this.show_pages = true;
      this.show_terms = true;
    }

    if (this.$route.path === '/politicas-de-privacidade') {
      this.show_pages = true;
      this.show_policy = true;
    }

    if (this.$route.path === '/faq') {
      this.show_pages = true;
      this.show_faq = true;
    }

    if (this.$route.path === '/ativacao-publica') {
      this.show_pages = true;
      this.show_authless_activation = true;
    }

    let hash = null;
    const hashConfirm = this.$route.path;
    if (hashConfirm.includes('/active/')) {
      hash = hashConfirm.split('/active/')[1];
      axios.get('/api/signup/activate/token/' + hash).then(res => {
        this.$router.push({
          name: 'home'
        });
        if (res) {
          this.modal_confirm_email.success = true;
          this.modal_confirm_email.modal = true;
        }
      }).catch(() => {
        this.$router.push({
          name: 'home'
        });
        this.modal_confirm_email.success = false;
        this.modal_confirm_email.modal = true;
      })
    } else if (hashConfirm.includes('/reset_password') && this.validEmail(this.$route.query.email) && this.$route.query.token.length > 0) {
      this.tokenPassword = true;
    }
    this.validToken();

    window._digisac = {
      id: "e734d330-f91b-4f9f-bf15-cdd8dcd437c6"
    };

    const s = document.createElement("script");
    s.async = true;
    s.src = "https://webchat.digisac.app/embedded.js";
    document.body.appendChild(s);
  },
  methods: {
    refreshPage() {
      location.reload();
    },
    hasToken: function () {
      return localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null;
    },
    validToken: function () {
      if (this.hasToken()) {
        axios.get('/api/user').then(res => {
          this.$store.dispatch('user/setUserData', res.data);
          if (res.data.active_mail === false && res.data.sms_verification_status === false) {
            this.required = true
          } else {
            this.required = false
          }
        })
            .catch(error => {
              if (error) {
                localStorage.removeItem('token');
                location.reload();
              }
            })
      }
    },
    validEmail: function (value) {
      var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value)
    },
    logout: function () {
      axios.post('/api/logout').then(res => {
        if (res) {
          localStorage.removeItem('token');
          location.reload();
        }
      });
    }
  },
  computed: {
    app_name: function () {
      return process.env.VUE_APP_NAME;
    },
    logo_url: function () {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_HIGH_CONTRAST_LOGO_NAME);
    },
    confirmationRequired: function () {
      return this.required;
    },
    activeItemMenu: function () {
      return this.$route.name;
    },
    hasTokenPassword: function () {
      return this.tokenPassword;
    },
    informationPage: function () {
      return process.env.VUE_APP_INFORMATION_PAGE;
    },
    buyCredits() {
      return process.env.VUE_APP_BUY_CREDITS;
    },
    regularize() {
      return process.env.VUE_APP_REGULARIZE;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    },
    activateVehicles() {
      return process.env.VUE_APP_ACTIVATE_VEHICLE;
    },
    activationsOCRHistory() {
      return process.env.VUE_APP_ACTIVATIONS_OCR_HISTORY;
    },
    appColor: function () {
      return process.env.VUE_APP_COLOR;
    },
    appLogo: function () {
      return '/img/logo/' + process.env.VUE_APP_LOGO_NAME;
    }
  }
};
</script>
<style scoped lang="scss">

.external-link {
  color: #000000;
  text-decoration: none;
}

.btn-blue {
  text-transform: capitalize !important;
  background: #000 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
}

.btn-blue:hover {
  background: transparent !important;
  color: #000 !important;
}

h5 {
  font-family: Roboto-Black !important;
  font-size: 24px !important;
  color: #58595B !important;
  text-align: center;
}

header {
  height: 55px;
  width: 100%;
  padding: 0 5vw;
}

.nav-user {
  width: 250px;
  height: 55px;
  background: rgb(0 0 0 / 0.3);
  margin-left: auto;
  color: #ffffff;
  font-family: Roboto-Light;
  display: flex;
  align-items: center;
  padding: 0 30px;
}

.nav-user:hover {
  cursor: pointer;
}

.nav-user-active {
  position: absolute;
  right: 5%;
  width: 250px;
  margin-top: 55px;
  color: #ffffff;
  font-family: Roboto-Regular;
  font-size: 14px;
  padding-right: 25px;
  z-index: 9;
}

.rotate {
  transform: rotate(180deg);
  transition-duration: 0.3s;
}

.nav-user-active li {
  background: rgb(0 0 0 / 0.3);
  padding: 10px;
  margin-bottom: 5px;
}

.nav-user-active li {
  color: #ffffff;
}

.nav-user-active li:hover {
  text-decoration: none;
}

.nav-user-active li:hover {
  background: #000;
  cursor: pointer;
}

.construct-container {
  padding: 40px 5vw;
  display: flex;
  flex-wrap: wrap;
  background: #eeeeee;
}

.nav {
  width: 250px;
  min-height: 100% !important;
  display: block;
}

.nav img {
  display: block;
  margin-left: 30px;
}

.nav ul {
  list-style: none;
  padding: 20px;
  display: block;
  width: 100%;
}

.nav ul li {
  padding: 10px;
  border-radius: 4px;
}

.nav ul li:hover {
  background: #ffffff;
  cursor: pointer;
}

.nav ul li.active {
  background: #ffffff;
}

.nav ul li.active h6 {
  font-family: Roboto-Bold !important;
}

.nav ul li h6 i {
  width: 20px;
}

.app-name {
  display: flex;
  align-items: stretch;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: Roboto-Bold;
  text-transform: uppercase;
  border-bottom: 2px solid #000;
  flex: 1;
  padding-bottom: 15px;
}

.nav ul li.title-list h6 {
  display: flex;
  align-items: stretch;
  margin-top: 20px;
  margin-bottom: 10px;
}

.nav ul li.title-list h6 {
  font-family: Roboto-Bold;
  text-transform: uppercase;
  border-bottom: 2px solid #000;
  flex: 1;
  padding-bottom: 15px;
}

.nav ul li:hover.title-list {
  color: #000;
  background: transparent;
  cursor: auto !important;
}

.content {
  flex: 1;
  margin-right: 25px;
}

.aside {
  width: 250px;
  height: 100%;
  background: transparent;
  border: 0;
  box-shadow: 0 0;
}

.btn-white {
  text-transform: capitalize !important;
  background: #ffffff !important;
  color: #e72c1f !important;
  font-family: Roboto-Black !important;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #e72c1f !important;
  margin: 0;
}

.btn-white:hover {
  background: transparent !important;
  color: #ffffff !important;
  border: 3px solid #ffffff !important;
}

@media only screen and (max-width: 500px) {
  .other-right {
    display: none;
  }
  .mobile-btn.active {
    margin-left: 0;
    right: 0;
    margin-right: 20px;
  }
}

@media only screen and (max-width: 1024px) {
  .nav {
    position: absolute;
    background: #ffffff;
    padding-top: 30px;
    top: 0;
    left: -250px;
    z-index: 10;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  }

  .nav.active {
    left: 0;
    transition: 2s;
    -webkit-transition: .5s;
    -moz-transition: .5s;
  }

  .mobile-btn {
    margin-top: 15px;
    display: block;
    color: #ffffff;
    width: 32px;
    height: 32px;
    border-top: 4px solid;
    position: absolute;
    -webkit-backface-visibility: hidden;
  }
  .mobile-btn.active {
    margin-left: 200px;
  }

  .mobile-btn::after, .mobile-btn::before {
    content: '';
    display: block;
    height: 5px;
    margin-top: 6px;
    background: currentColor;
    position: relative;
    transition: transform .2s ease;
  }

  .mobile-btn.active {
    border-top-color: transparent;
  }

  .mobile-btn.active::after {
    margin-top: 0px;
    top: 2px;
    transform: rotate(45deg);
  }

  .mobile-btn.active::before {
    margin-top: 0px;
    top: 6px;
    transform: rotate(135deg);
  }
}
</style>
<style lang="scss">
@font-face {
  font-family: Roboto-Black;
  src: url('./assets/fonts/Roboto-Black.ttf');
}

@font-face {
  font-family: Roboto-Bold;
  src: url('./assets/fonts/Roboto-Bold.ttf');
}

@font-face {
  font-family: Roboto-Regular;
  src: url('./assets/fonts/Roboto-Regular.ttf');
}

@font-face {
  font-family: Roboto-Light;
  src: url('./assets/fonts/Roboto-Light.ttf');
}

@font-face {
  font-family: Roboto-Thin;
  src: url('./assets/fonts/Roboto-Thin.ttf');
}

html, body {
  background: #EEEEEE;
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: Roboto-Regular;
  color: #595959;
  font-size: 14px;
}

.error--text {
  color: #e72c1f !important;
}

.title-modal {
  font-size: 28px;
  font-family: Roboto-Black;
  color: #595959;
}

.btn-confirm {
  text-transform: uppercase !important;
  background: #000 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  min-width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
  margin: 15px 5px;
}

.btn-confirm:hover {
  background: transparent !important;
  color: #000 !important;
}

.btn-confirm:disabled {
  background: transparent !important;
  opacity: 0.3;
}

.btn-confirm-outlined {
  text-transform: uppercase !important;
  background: transparent !important;
  color: #000 !important;
  font-family: Roboto-Black !important;
  min-width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
  margin: 15px 5px;
}

.btn-confirm-outlined:hover {
  background: #000 !important;
  color: #ffffff !important;
}

.btn-icon {
  border: 0;
  width: 28px;
  height: 28px;
  background: #ECEDF0;
  padding: 0;
  margin: 0 5px;
}

.btn-icon i {
  font-size: 14px;
  color: #3f3f3f;
}

.form-card {
  padding: 30px;
}

.resume-action {
  margin-top: 30px;
  border-top: 1px dashed #cdcdcd;
  border-bottom: 1px dashed #cdcdcd;
  padding: 15px 0;
}

.resume-action h6 {
  color: #595959;
  font-family: Roboto-Regular;
  display: flex;
  justify-content: center;
}

.resume-action h6 span {
  font-family: Roboto-Black;
  margin-right: 5px;
}

.message-data {
  color: #595959;
  font-size: 14px;
  margin: 10px 0;
  padding-top: 35px;
}

.message-data span {
  font-family: Roboto-Light;
  margin: 5px;
}

.snackbar-success {
  color: #ffffff;
  font-size: 16px;
}

.subtitle-modal {
  border-radius: 4px;
  width: 100%;
  padding: 10px;
  font-family: Roboto-Black;
  color: #595959;
  font-size: 14px;
  background: #f5f5f5;
}

.btn-cancel {
  text-transform: uppercase !important;
  background: #e72c1f !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  min-width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #e72c1f !important;
  margin: 15px 5px;
}

.btn-cancel:hover {
  background: transparent !important;
  color: #e72c1f !important;
}

.btn-cancel:disabled {
  background-color: #fff !important;
  border-color: #818181 !important;
  opacity: 0.6;
}

.btn-green {
  text-transform: uppercase !important;
  background: #28a745 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  min-width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #28a745 !important;
  margin: 15px 5px;
}

.btn-green:hover {
  background: transparent !important;
  color: #28a745 !important;
}

.v-application--wrap {
  min-height: 0;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0 !important;
}

.v-application .error {
  background-color: #e72c1f !important;
}

.icon-close-modal {
  font-size: 24px;
}

.icon-close-modal:hover {
  cursor: pointer;
  color: #000;
}

.v-dialog .v-card__text {
  font-family: Roboto-Regular !important;
  font-size: 18px !important;
}

.v-dialog .v-card__text .bold-text {
  font-family: Roboto-Black !important;
  font-size: 18px !important;
}

.mobile-btn {
  display: none;
}

.mobile-btn:hover {
  cursor: pointer;
}

@media only screen and (max-width: 500px) {
  .icon-close-modal {
    position: absolute;
    right: 0;
    top: 0;
    margin: 20px;
  }
}

@media only screen and (max-width: 1345px) {
  .aside {
    display: none;
  }
  .content {
    margin-right: 0 !important;
  }

  .nav {
    height: 100vh;
  }
}

.logo-size {
  max-width: 157px;
}
</style>
